import Vue from 'vue'

import { Popup, Collapse, CollapseItem, Swipe, SwipeItem } from 'vant'

Vue.use(Popup).use(Collapse).use(CollapseItem).use(Swipe).use(SwipeItem)
